import { Contact } from "src/app/services/response-models/contacts.response.model";

export class SetCreatedContact {
    static readonly type = "[Contacts] Set created contact";

    constructor(public payload: Contact) {}
}
